import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import api from "../../api";
import { createAsyncThunkInstance } from "../createAsyncThunkInstance";
import { ICommonInitialState } from "../../shared/types/storeTypes";
import { INotificationRequest, Notification as AppNotification } from "@/model/notifications";

interface INotificationsState extends ICommonInitialState {
  notifications: AppNotification[];
  notificationsCount: number;
}

const initialState: INotificationsState = {
  notifications: [],
  notificationsCount: 0,
  isLoading: false,
  error: null,
};

export const fetchNotifications = createAsyncThunkInstance<AppNotification[], INotificationRequest>(
  "notifications/fetchNotifications",
  api.notifications.getNotifications,
);

export const markViewed = createAsyncThunkInstance<void, number>("notifications/markViewed", api.notifications.markViewed);

export const markUnviewed = createAsyncThunkInstance<void, number>("notifications/markUnviewed", api.notifications.markUnviewed);

export const markAllViewed = createAsyncThunkInstance<void>("notifications/markAllViewed", api.notifications.markAllViewed);

export const deleteAllArchive = createAsyncThunkInstance<void>("notifications/markAllUnviewed", api.notifications.deleteAllArchive);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotificationsCount: (state, action: PayloadAction<number>) => {
      state.notificationsCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload;
      });
  },
});

export const { setNotificationsCount } = notificationsSlice.actions;
export const notificationsReducer = notificationsSlice.reducer;
